import { render, staticRenderFns } from "./StrategyLevels.vue?vue&type=template&id=455552fd&scoped=true&"
import script from "./StrategyLevels.vue?vue&type=script&lang=js&"
export * from "./StrategyLevels.vue?vue&type=script&lang=js&"
import style0 from "./StrategyLevels.vue?vue&type=style&index=0&id=455552fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455552fd",
  null
  
)

export default component.exports